// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './router'; // el que creaste arriba
import { AuthProvider } from "./context/AuthContext";
// import 'bootstrap/dist/css/bootstrap.min.css';
import './style/bootstrap-custom.scss';
import './style/App.scss';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n/index.js';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);

reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("ServiceWorker registrado con éxito:", registration);
      })
      .catch((error) => {
        console.log("Error al registrar el ServiceWorker:", error);
      });
  });
}
